var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOntiltleftBare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "176.76566mm",
    height: "152.12579mm",
    viewBox: "0 0 176.76566 152.12579",
    id: "svg1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath166-3",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path164-6",
    d: "M 0,66 H 85 V 0 H 0 Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-15.375865,-73.041693)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g160-1-9",
    transform: "matrix(4.1216123,0,0,-4.222081,-49.306657,288.43242)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g162-9",
    clipPath: "url(#clipPath166-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g168-6-0",
    transform: "translate(42.5,49)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0.56,0 1.01,-0.45 1.01,-1.01 0,-0.55 -0.45,-1 -1.01,-1 -0.56,0 -1.01,0.45 -1.01,1 C -1.01,-0.45 -0.56,0 0,0 M 13.77,-6.53 7.7,-3.02 1.31,0.66 C 0.9,0.89 0.45,1.02 0,1.02 -0.45,1.02 -0.91,0.89 -1.32,0.66 l -6.38,-3.68 -6.07,-3.51 c -0.81,-0.47 -1.31,-1.34 -1.31,-2.28 v -14.38 c 0,-0.94 0.5,-1.81 1.31,-2.28 l 12.45,-7.19 c 0.41,-0.23 0.87,-0.36 1.32,-0.36 0.45,0 0.9,0.13 1.31,0.36 l 12.46,7.19 c 0.81,0.47 1.31,1.34 1.31,2.28 v 14.38 c 0,0.94 -0.5,1.81 -1.31,2.28",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path170-6-7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g172-3-9",
    transform: "translate(42.5,49.0043)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0.556,0 1.011,-0.455 1.011,-1.011 0,-0.557 -0.455,-1.002 -1.011,-1.002 -0.556,0 -1.011,0.445 -1.011,1.002 C -1.011,-0.455 -0.556,0 0,0 Z M 11.371,-22.566 0,-29.143 l -11.371,6.567 v 13.143 l 4.674,2.699 H 6.697 l 4.674,-2.699 z m 2.403,16.027 -6.076,3.515 -6.39,3.682 C 0.9,0.89 0.454,1.011 0,1.011 -0.454,1.011 -0.909,0.89 -1.317,0.658 l -6.381,-3.682 -6.076,-3.515 c -0.807,-0.464 -1.307,-1.336 -1.307,-2.272 v -14.386 c 0,-0.937 0.5,-1.809 1.307,-2.273 l 12.457,-7.197 c 0.408,-0.232 0.863,-0.353 1.317,-0.353 0.445,0 0.9,0.121 1.308,0.353 l 12.466,7.197 c 0.807,0.464 1.307,1.336 1.307,2.273 v 14.386 c 0,0.936 -0.5,1.808 -1.307,1.272 z",
    style: {
      fill: "none",
      stroke: "#898345",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path174-8-7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g176-9-9",
    transform: "translate(42.5,34.994)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -1.099,0 -1.994,-0.894 -1.994,-1.994 0,-1.099 0.895,-1.993 1.994,-1.993 1.1,0 1.994,0.894 1.994,1.993 C 1.994,-0.894 1.1,0 0,0 m 0,-5.842 c -2.122,0 -3.849,1.726 -3.849,3.848 0,2.123 1.727,3.849 3.849,3.849 2.122,0 3.849,-1.726 3.849,-3.849 0,-2.122 -1.727,-3.848 -3.849,-3.848",
    style: {
      fill: "#898345",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path178-6-4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g180-0-1",
    transform: "translate(53.8713,26.4379)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 -11.371,-6.576 -11.372,6.567 v 13.143 l 4.675,2.699 H -4.675 L 0,13.134 Z m -11.371,22.566 c 0.556,0 1.011,-0.454 1.011,-1.011 0,-0.556 -0.455,-1.001 -1.011,-1.001 -0.557,0 -1.011,0.445 -1.011,1.001 0,0.557 0.454,1.011 1.011,1.011 m 13.773,-6.539 -6.075,3.516 -6.391,3.682 c -0.408,0.232 -0.853,0.352 -1.307,0.352 -0.455,0 -0.909,-0.12 -1.317,-0.352 l -6.382,-3.682 -6.075,-3.516 c -0.807,-0.463 -1.308,-1.335 -1.308,-2.272 V -0.631 c 0,-0.937 0.501,-1.808 1.308,-2.272 l 12.457,-7.198 c 0.408,-0.232 0.862,-0.352 1.317,-0.352 0.445,0 0.899,0.12 1.307,0.352 l 12.466,7.198 c 0.807,0.464 1.308,1.335 1.308,2.272 v 14.386 c 0,0.937 -0.501,1.809 -1.308,2.272",
    style: {
      fill: "#34332b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path182-0-7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g184-0-5",
    transform: "translate(45.4212,33.0005)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,-1.613 -1.308,-2.921 -2.921,-2.921 -1.613,0 -2.921,1.308 -2.921,2.921 0,1.613 1.308,2.921 2.921,2.921 C -1.308,2.921 0,1.613 0,0",
    style: {
      fill: "#34332b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path186-4-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g188-3-8",
    transform: "translate(21.234,26.1737)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 V 0 C -0.662,0 -1.274,0.353 -1.605,0.926 L -4.26,5.519 c -0.232,0.408 -0.353,0.862 -0.353,1.307 0,0.455 0.121,0.909 0.353,1.318 l 2.646,4.582 c 0.331,0.574 0.943,0.927 1.605,0.927 h 0.003 c 1.428,0 2.32,-1.545 1.606,-2.781 L -0.2,7.755 C -0.531,7.18 -0.531,6.473 -0.199,5.899 L 1.605,2.783 C 2.32,1.547 1.428,0 0,0",
    style: {
      fill: "#34332b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path190-8-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g192-4-3",
    transform: "translate(22.1585,37.968)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,0.214 -0.079,0.383 -0.128,0.468 -0.08,0.139 -0.319,0.463 -0.802,0.463 -0.333,0 -0.641,-0.177 -0.806,-0.463 l -2.645,-4.582 c -0.294,-0.516 -0.305,-1.164 0.003,-1.704 l 2.652,-4.586 c 0.164,-0.286 0.472,-0.463 0.801,-0.463 0.484,0 0.723,0.324 0.804,0.464 0.078,0.139 0.241,0.509 -0.001,0.927 l -1.804,3.116 c -0.498,0.857 -0.497,1.924 -0.001,2.784 l 1.799,3.117 C -0.033,-0.295 0,-0.138 0,0 m -6.465,-4.968 c 0,0.617 0.164,1.23 0.474,1.776 l 2.649,4.588 c 0.496,0.858 1.419,1.39 2.409,1.39 1.008,0 1.909,-0.52 2.412,-1.391 0.502,-0.871 0.502,-1.912 0,-2.781 l -1.8,-3.117 c -0.164,-0.286 -0.164,-0.642 0,-0.927 l 1.804,-3.116 c 0.503,-0.871 0.506,-1.91 0.002,-2.784 -0.502,-0.871 -1.403,-1.392 -2.41,-1.392 -0.99,0 -1.912,0.533 -2.407,1.389 l -2.656,4.593 c -0.313,0.552 -0.477,1.163 -0.477,1.772",
    style: {
      fill: "#898345",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path194-8-7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g196-8-2",
    transform: "translate(21.234,26.1737)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 V 0 C -0.662,0 -1.274,0.353 -1.605,0.926 L -4.26,5.519 c -0.232,0.408 -0.353,0.862 -0.353,1.307 0,0.455 0.121,0.909 0.353,1.318 l 2.646,4.582 c 0.331,0.574 0.943,0.927 1.605,0.927 h 0.003 c 1.428,0 2.32,-1.545 1.606,-2.781 L -0.2,7.755 C -0.531,7.18 -0.531,6.473 -0.199,5.899 L 1.605,2.783 C 2.32,1.547 1.428,0 0,0",
    style: {
      fill: "#34332b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path198-3-8"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOntiltleftBare);
export default __webpack_public_path__ + "static/media/ontiltleft-bare.979a3a9185bb9a3788b2236c00152224.svg";
export { ForwardRef as ReactComponent };